module.exports = __webpack_public_path__ + "img/hardyArms1.6fe45bea.png";